import { UserInfo } from 'app/services/edpApiV1/substitutions';
import style from './index.module.scss';

interface IProps {
  user: UserInfo;
  suffix?: string;
  showPersonnelNumber?: boolean;
  initials?: boolean;
  bold?: boolean;
}

// Компонент отрисовки основной информации о пользователе
export const SummaryInfo: React.FC<IProps> = ({
  user,
  suffix,
  showPersonnelNumber = true,
  initials = false,
  bold = false,
}) => {
  const { name, middleName, lastName, personnelNumber } = user;
  return (
    <div>
      <div className={`${style.employee} ${bold ? style.bold : ''}`}>
        {(() => {
          if (initials) {
            return (
              <span>
                {(() => {
                  if (!lastName && !middleName) {
                    return name;
                  }
                  if (!middleName) {
                    return lastName + ' ' + name;
                  }
                  return `${lastName || ''} ${name ? name[0] : ''}. ${middleName ? middleName[0] : ''}.`;
                })()}
              </span>
            );
          }
          return <span> {`${lastName || ''} ${name || ''} ${middleName || ''}`}</span>;
        })()}
        <span className={style.suffix}>{suffix && suffix}</span>
      </div>
      {showPersonnelNumber && <div className={style.personalNumber}>{personnelNumber}</div>}
    </div>
  );
};
